'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Popup = require('rmc-picker/lib/Popup');

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

var PopupDatePicker = _react2["default"].createClass({
    displayName: 'PopupDatePicker',
    getDefaultProps: function getDefaultProps() {
        return {
            pickerValueProp: 'date',
            pickerValueChangeProp: 'onDateChange'
        };
    },
    onOk: function onOk(v) {
        var _props = this.props,
            onChange = _props.onChange,
            onOk = _props.onOk;

        if (onChange) {
            onChange(v);
        }
        if (onOk) {
            onOk(v);
        }
    },
    render: function render() {
        return _react2["default"].createElement(_Popup2["default"], __assign({ picker: this.props.datePicker, value: this.props.date }, this.props, { onOk: this.onOk }));
    }
});
exports["default"] = PopupDatePicker;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rmc-date-picker/lib/Popup.js
 ** module id = 445
 ** module chunks = 0
 **/